import IconToastError from '@/icons/toast-error.svg';

function PaymentError(props) {
	return (
		<div className="flex items-center gap-2.5 rounded border border-red px-3 py-2">
			<IconToastError className="size-5 text-red" />
			<p className="text-sm font-semibold text-red" {...props} />
		</div>
	);
}

export default PaymentError;
